import { gql } from '@apollo/client/core';

export const changeOrganizationMemberOwner = gql`
  mutation changeOrganizationMemberOwner($member: String!, $orgCode: String!) {
    admin {
      changeOrganizationMemberOwner(member: $member, organization: $orgCode) {
        code
        adviseMessage {
          code
          description
        }
      }
    }
  }
`;
